import i18n from "@/i18n";
import Vue from "vue";

export function useSchedullingActions() {
  const CANCEL_ACTION = {
    code: "cancel",
    icon: "mdi-window-close",
    title: Vue.prototype.$capitalize(
      i18n.tc("model.schedulings_cancel_button")
    ),
    color: "red",
    hidden: true,
  };

  const FAILURE_ACTION = {
    code: "failure",
    icon: "mdi-phone-alert",
    title: "Insucesso",
    color: "warning",
  };

  const SCHEDULE_ACTION = {
    code: "schedule",
    icon: "mdi-phone",
    title: Vue.prototype.$capitalize(i18n.tc("model.schedulings_to_schedule")),
    color: "primary",
  };

  const REFUSE_ACTION = {
    code: "refuse",
    icon: "mdi-hand-back-left",
    title: Vue.prototype.$capitalize(
      i18n.tc("model.schedulings_refused_by_injured")
    ),
    color: "red",
    hidden: true,
  };

  const SHOW_LOGS = {
    code: "logs",
    icon: "mdi-history",
    title: Vue.prototype.$capitalize(i18n.tc("model.schedulings_show_history")),
    color: "secondary",
    hidden: true,
  };

  return {
    CANCEL_ACTION,
    FAILURE_ACTION,
    SCHEDULE_ACTION,
    REFUSE_ACTION,
    SHOW_LOGS,
  };
}
